import { bootstrapApplication } from '@angular/platform-browser';
import { logEventqEnvironmentOnBoot, logOktaDebug } from './app/core/auth/okta-debug-log';
import { appConfig } from './app/app.config';
import { App } from './app/app';

logEventqEnvironmentOnBoot();
logOktaDebug('main.ts: before bootstrapApplication');

bootstrapApplication(App, appConfig)
  .then(() => {
    logOktaDebug('main.ts: bootstrapApplication resolved');
  })
  .catch((err) => {
    logOktaDebug('main.ts: bootstrapApplication rejected', {
      error: err instanceof Error ? { name: err.name, message: err.message, stack: err.stack } : String(err),
    });
    console.error(err);
  });
